var React = require('react');

function LogoLines (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_46","data-name":"Group 46","style":{"isolation":"isolate"}},[React.createElement("path",{"id":"Path_35","data-name":"Path 35","d":"M7.436,0V127.251l5.64-6.189V6.21Z","transform":"translate(-0.151)","fill":"#dab25b","key":0}),React.createElement("path",{"id":"Path_36","data-name":"Path 36","d":"M121.067,0V272.7l8.483-9.334V9.335Z","transform":"translate(-2.461)","fill":"#dab25b","key":1}),React.createElement("path",{"id":"Path_37","data-name":"Path 37","d":"M239.588,0V395.065l11.3-12.419V12.44Z","transform":"translate(-4.871)","fill":"#dab25b","key":2}),React.createElement("path",{"id":"Path_38","data-name":"Path 38","d":"M20.976,0,0,23.067Z","fill":"#dab25b","key":3})]));
}

LogoLines.defaultProps = {"width":"246.02","height":"395.065","viewBox":"0 0 246.02 395.065"};

module.exports = LogoLines;

LogoLines.default = LogoLines;
